import { createSelector } from '@ngrx/store';

import { IScanDocumentData } from '@partners/api';
import { IRootState } from '../../../root';
import { IScanDocumentState } from './scan.state';

export class ScanSelectors {
  static readonly ScanDocumentState = (state: IRootState): IScanDocumentState => {
    return state.scanDocument as IScanDocumentState;
  };

  static readonly scanDocumentStateModel = createSelector(
    ScanSelectors.ScanDocumentState,
    (scanDocument: IScanDocumentState) => {
      return scanDocument.model;
    }
  );
  static readonly scanDocumentStateError = createSelector(
    ScanSelectors.ScanDocumentState,
    (scanDocument: IScanDocumentState) => {
      return scanDocument.error;
    }
  );
  static readonly scanDocumentStateData = createSelector(
    ScanSelectors.ScanDocumentState,
    (scanDocument: IScanDocumentState) => {
      return scanDocument.data;
    }
  );

  static readonly isScanRetryAttempt = createSelector(
    ScanSelectors.ScanDocumentState,
    (scanDocument: IScanDocumentState) => {
      return scanDocument.error?.error?.severity?.severityCode === 'W_0711';
    }
  );

  static readonly data = createSelector(ScanSelectors.ScanDocumentState, (scanDocument: IScanDocumentState) => {
    return scanDocument.data;
  });

  static readonly lastScanAction = createSelector(ScanSelectors.data, (data: IScanDocumentData) => {
    return data?.lastScanAction;
  });
}
